module.exports = {
  en: {
    'HRES6EUC1': {
      '0': '[HRES6EU] Change of Shift Schedule',
      '10': '[HRES6EU] Change of Shift Schedule',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req. Date',
      '55': 'Seq. No.',
      '60': 'Work Date',
      '70': 'Shift Change(Day- Shift)',
      '80': 'Old',
      '90': '1st',
      '100': '2nd',
      '110': 'New',
      '120': '1st',
      '130': '2nd',
      '140': 'Status ',
      '150': 'Approve By',
      '160': 'Appr. Date',
      '170': 'Remark',
      '180': 'Next Approve'
    },
    'HRES6EUC2': {
      '0': 'Detail of Approve',
      '10': 'For Emp. Code',
      '20': 'Seq.No.',
      '30': 'Approved by',
      '40': 'Date',
      '50': 'Current Status',
      '60': 'Status',
      '70': 'Approved',
      '80': 'Refused',
      '90': 'Remark',
      '100': 'No.of  selected',
      '110': 'Record'
    },
    'HRES6EUC3': {
      '0': 'Details Of Change for Shift Schedule',
      '10': 'Emp. Code',
      '20': 'Request Date',
      '30': 'Working Date',
      '40': 'Details Of Change',
      '50': 'Type of day- Old',
      '60': 'Type Of day- new',
      '70': 'Shift code-old',
      '80': 'Shift code-new',
      '90': 'Time In-Out old',
      '100': 'Time In-Out new',
      '110': 'Details of Change - Shift 2',
      '120': 'Type of day- Old',
      '130': 'Type of day- new',
      '140': 'Shift code-old',
      '150': 'Shift code-new',
      '160': 'Time In-Out old',
      '170': 'Time In-Out new',
      '180': 'Reason of Change',
      '190': 'Shift Schedule',
      '200': 'Update By'
    },
    'HRES6EUC4': {
      '0': 'Shift Schedule ',
      '10': 'For Year',
      '20': 'Month',
      '30': 'Type of Day',
      '40': 'Working Day',
      '50': 'Holiday',
      '60': 'Traditional Day',
      '70': 'Leave',
      '80': 'Shut down',
      '90': 'Other'
    }
  },
  th: {
    'HRES6EUC1': {
      '0': '[HRES6EU] อนุมัติการขอแก้ไขเวลาทำงาน',
      '10': '[HRES6EU] อนุมัติการขอแก้ไขเวลาทำงาน',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ยื่น',
      '55': 'ลำดับที่',
      '60': 'วันทำงาน',
      '70': 'กะที่เปลี่ยน(วัน - กะ)',
      '80': 'เดิม',
      '90': '1st',
      '100': '2nd',
      '110': 'ใหม่',
      '120': '1st',
      '130': '2nd',
      '140': 'สถานะปัจจุบัน',
      '150': 'ผู้อนุมัติ',
      '160': 'วันที่อนุมัติ',
      '170': 'หมายเหตุการอนุมัติ',
      '180': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES6EUC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่',
      '50': 'สถานะปัจจุบัน',
      '60': 'สถานะ',
      '70': 'อนุมัติ',
      '80': 'ไม่อนุมัติ',
      '90': 'หมายเหตุ',
      '100': 'รายการที่เลือกทั้งหมด',
      '110': 'รายการ'
    },
    'HRES6EUC3': {
      '0': 'รายละเอียดการขอแก้ไขเวลาทำงาน',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ยื่นคำร้อง',
      '30': 'วันที่ทำงาน',
      '40': 'รายละเอียดการขอแก้ไข',
      '50': 'ประเภทวัน-เดิม',
      '60': 'ประเภทวัน-ใหม่',
      '70': 'รหัสกะ-เดิม',
      '80': 'รหัสกะ-ใหม่',
      '90': 'กำหนดเวลาเข้าออก-เดิม',
      '100': 'กำหนดเวลาเข้าออก-ใหม่',
      '110': 'รายละเอียดการขอแก้ไข',
      '120': 'ประเภทวัน-เดิม',
      '130': 'ประเภทวัน-ใหม่',
      '140': 'รหัสกะ-เดิม',
      '150': 'รหัสกะ-ใหม่',
      '160': 'กำหนดเวลาเข้าออก-เดิม',
      '170': 'กำหนดเวลาเข้าออก-ใหม่',
      '180': 'เหตุผลในการขอเปลี่ยน',
      '190': 'ตารางการทำงาน',
      '200': 'ผู้บันทึก'
    },
    'HRES6EUC4': {
      '0': 'ตารางปฏิบัติงาน',
      '10': 'สำหรับปี',
      '20': 'เดือน',
      '30': 'ประเภทวันทำงาน',
      '40': 'เวลาทำงานปกติ',
      '50': 'วันหยุด',
      '60': 'วันหยุดประเพณี',
      '70': 'การลา',
      '80': 'Shut down',
      '90': 'อื่นๆ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6eu.js